import { AppContext } from "~/contexts/AppContext"
import { useContext } from "react"
import api from "~/services/api"

function useAppContext() {
  const {
    supabase,
    apiService,
    isMobile,
    setIsMobile,
    isTablet,
    setIsTablet,
    activePanel,
    setActivePanel,
    templates,
    setTemplates,
    shapes,
    setShapes,
    activeSubMenu,
    setActiveSubMenu,
    uploads,
    setUploads,
    currentTemplate,
    setCurrentTemplate,
    skuData,
    setSkuData,
  } = useContext(AppContext)
  return {
    supabase,
    apiService,
    isMobile,
    setIsMobile,
    isTablet,
    setIsTablet,
    activePanel,
    setActivePanel,
    templates,
    setTemplates,
    shapes,
    setShapes,
    activeSubMenu,
    setActiveSubMenu,
    uploads,
    setUploads,
    currentTemplate,
    setCurrentTemplate,
    skuData,
    setSkuData,
  }
}

export default useAppContext
